

import React, { memo } from 'react';
import { SizeMe } from 'react-sizeme';
import Stage from './Stage';
import Dropdown from '../../Dropdown';
import { NUMERIC_MEDIA_SIZES } from '../../../common/styles/vars';
import '../styles/_stages.scss';


















function getOnClickHandler(onClick, index, totalStages) {
  return () => onClick(index, totalStages);
}

function getDropdownHandler(onClick) {
  return onClick ? ({ value: index }) => onClick(index) : void 0;
}

function renderDropdownOption({
  stage: { text, disabled },
  stageNumber



}) {
  return { label: text, value: stageNumber, disabled };
}

function Stages({
  stages,
  currentStage = 1,
  hideStageNumbers,
  onClick,
  forceStageDisplay = false
}) {
  return (
    <SizeMe>
      {({ size }) =>
      <div className="stages">
          {size.width >= NUMERIC_MEDIA_SIZES.small || forceStageDisplay ?
        <div className="stages__list">
              {stages.map(
            ({ text, minText, subtitle, disabled, showLoader, statusDot }, index) =>
            <Stage
              key={text}
              selected={index === currentStage - 1}
              text={text}
              minText={minText}
              subtitle={subtitle}
              onClick={
              onClick ?
              getOnClickHandler(onClick, index + 1, stages.length) :
              void 0}

              disabled={disabled}
              showLoader={showLoader}
              statusDot={statusDot} />


          )}
            </div> :

        <Dropdown
          className="stages__dropdown"
          defaultValue={renderDropdownOption({
            stage: stages[currentStage - 1],
            stageNumber: currentStage
          })}
          onChange={getDropdownHandler(onClick)}
          options={stages.map((stage, index) => renderDropdownOption({
            stage,
            currentStage,
            stageNumber: index + 1,
            hideStageNumbers
          })
          )}
          type="BUTTON" />}


        </div>}

    </SizeMe>);

}

export default memo(Stages);